export default __webpack_public_path__ + "media/images/modifier_v2-b78cf25625f1cad60c8c6458d28cd8c0.png";